"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const chart_type_model_1 = require("../../../../controls/chart/shared/chart-type.model");
class PieChartOptions {
    constructor(selectedColorPaletteId) {
        /**
         *  Chart type
         * @type {ChartType}
         * @private
         */
        this._chartType = chart_type_model_1.ChartType.PIE;
        /**
         * Selected color palette id, which specified the colors set of report.
         * @type {number}
         * @private
         */
        this._selectedPaletteId = 0;
        selectedColorPaletteId !== undefined && (this.selectedPaletteId = selectedColorPaletteId);
    }
    get chartType() {
        return this._chartType;
    }
    set selectedPaletteId(selectedPaletteId) {
        this._selectedPaletteId = selectedPaletteId;
    }
    get selectedPaletteId() {
        return this._selectedPaletteId;
    }
    toJsonString() {
        let toJsonData = "";
        toJsonData += "{";
        toJsonData += "\"selectedColorPaletteId\":";
        toJsonData += this.selectedPaletteId;
        toJsonData += "}";
        return toJsonData;
    }
    fromJson(jsonObject) {
        jsonObject.selectedColorPaletteId !== undefined && (this._selectedPaletteId = jsonObject.selectedColorPaletteId);
    }
}
exports.PieChartOptions = PieChartOptions;
//# sourceMappingURL=pie-chart-options.model.js.map